import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { EllipsisPipe } from '../../../../core/pipes/ellipsis.pipe';
import { AuthGuardService } from '../../../../core/services/auth/auth-guard.service';
import { SharedModule } from '../../../../shared/shared-module';
import { I18nService } from '../../../../core/services/i18n.service';

@Component({
  selector: '[app-nav]',
  imports: [SharedModule, EllipsisPipe],
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavComponent {
  picturePath = signal('');
  userName = signal('');
  menuOpen = false;
  routerLinkActiveOptions = {
    exact: true,
  }; // as IsActiveMatchOptions;

  constructor(public authGuardService: AuthGuardService, public i18nService: I18nService) {
    effect(
      () => {
        this.picturePath.set(this.authGuardService.currentUser?.picturePath);
      },
      // { allowSignalWrites: true },
    );
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  // Mega Tool

  isOpen: boolean = false;
}
